export const ENTORNO = 'produccionMoviportHTTPS';

const localMoviport = {
  url: '//localhost',
  port: '3001',
  realTimeServerUrl: '//localhost',
  realTimeServerPort: '3001',
};

const produccionMoviport = {
  url: 'http://52.27.239.196',
  port: '3000',
  realTimeServerUrl: 'http://52.27.239.196',
  realTimeServerPort: '3000',
};

const produccionMoviportHTTPS = {
  url: 'https://proveedores.moviportsa.com.ar',
  realTimeServerUrl: 'https://proveedores.moviportsa.com.ar',
};

const localCasport = {
  url: '//localhost',
  port: '3001',
  realTimeServerUrl: '//localhost',
  realTimeServerPort: '3001',
};

const produccionCasport = {
  url: 'http://184.33.234.163',
  port: '3000',
  realTimeServerUrl: 'http://184.33.234.163',
  realTimeServerPort: '3000',
};

const produccionCasportHTTPS = {
  url: 'https://proveedores.casport.com.ar',
  realTimeServerUrl: 'https://proveedores.casport.com.ar',
};

export function getRealTimeServerURL() {
  switch (ENTORNO) {
    case 'localMoviport':
      return `${localMoviport.realTimeServerUrl}:${localMoviport.realTimeServerPort}`;
      break;
    case 'produccionMoviport':
      return `${produccionMoviport.realTimeServerUrl}:${produccionMoviport.realTimeServerPort}`;
      break;
    case 'produccionMoviportHTTPS':
      return `${produccionMoviportHTTPS.realTimeServerUrl}`;
      break;
    case 'localCasport':
      return `${localCasport.realTimeServerUrl}:${localCasport.realTimeServerPort}`;
      break;
    case 'produccionCasport':
      return `${produccionCasport.realTimeServerUrl}:${produccionCasport.realTimeServerPort}`;
      break;
    case 'produccionCasportHTTPS':
      return `${produccionCasportHTTPS.realTimeServerUrl}`;
      break;
  }
}

export function getServerURL() {
  switch (ENTORNO) {
    case 'localMoviport':
      return `${localMoviport.url}:${localMoviport.port}/api`;
      break;
    case 'produccionMoviport':
      return `${produccionMoviport.url}:${produccionMoviport.port}/api/`;
      break;
    case 'produccionMoviportHTTPS':
      return `${produccionMoviportHTTPS.url}/api/`;
      break;
    case 'localCasport':
      return `${localCasport.url}:${localCasport.port}/api`;
      break;
    case 'produccionCasport':
      return `${produccionCasport.url}:${produccionCasport.port}/api/`;
      break;
    case 'produccionCasportHTTPS':
      return `${produccionCasportHTTPS.url}/api/`;
      break;
  }
}